<template>
  <div class="search_result_wrapper">
    <div class="result_count">“{{seachTypeText}}” 該当<span>{{resultLength}}</span>件</div>
    <div class="result_wrapper">
      <div class="result_scroller">
        <div class="shop_list" v-for="(result, i) of results" :key="i">
          <dl @click="selectList(result.id)">
            <dt>
              <img src="../../assets/images/map/shop_icon.svg" alt="店舗" v-if="result.siten_flg">
              <img src="../../assets/images/map/atm_icon.svg" alt="ATM" v-if="!result.siten_flg">
            </dt>
            <dd>
              <div class="shop_status" v-if="result.siten_flg">
                <div class="badge sales" v-if="result.sales === '1'">営業中</div>
                <div class="badge off_hours" v-if="result.sales === '2'">時間外</div>
                <div class="badge off_hours" v-if="result.sales === '3'">窓口昼休業</div>
                <span class="atm_status" v-if="(result.sales === '2' || result.sales === '3') && (result.atm === '1')">ATM稼働中</span>
              </div>
              <div class="shop_status" v-if="!result.siten_flg">
                <div class="badge sales" v-if="result.atm === '1'">営業中</div>
                <div class="badge off_hours" v-if="result.atm === '2'">時間外</div>
              </div>
              <p class="shop_name">{{result.tenpo}}</p>
              <p class="shop_address">
                <span class="shop_postalcode" v-if="result.siten_flg && result.yuubin">〒{{result.yuubin}}</span>
                {{result.address}}
              </p>
            </dd>
          </dl>
          <div class="shop_list_bottom">
            <div class="card_bottom_left">
              <img src="../../assets/images/map/distance_pin.svg" alt="距離">
              <span v-if="result.distance >= 1000">{{toFixedChange(result.distance)}}km</span>
              <span v-else>{{result.distance}}m</span>
            </div>
            <div class="card_bottom_right">
              <a :href="encodeURL(result)" target="_blank" class="square_button">ルート案内</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import store from '../../store/store';

export default {
  name: 'SearchResult',
  components: {
  },
  directives: {
  },
  props: {
    result: Array
  },
  data() {
    return {
      resultLength: 0,
      badgeText: '',
      atmText: '',
      seachTypeText: '',
    };
  },
  computed: {
    results: function() {
      console.log( this.result)
      let result=[]
      const inputName=store.getters.inputName;
      if(inputName===""){
        return this.result;
      }
      //ソート
      //完全一致
      let kanzen=_.clone(this.result.filter((d)=>d.tenpo===inputName))
        console.log( kanzen)
      //部分一致店舗
      let bubunTnpo=_.clone(this.result.filter((d)=>{
        if((d.tenpo!==inputName)&&(d.atm=="2" )) {
          return d
        }
        }));
        console.log( bubunTnpo)
      //部分一致atm
      let bubunatm=_.clone(this.result.filter((d)=>{
        if((d.tenpo!==inputName)&&(d.atm=="1" )) {
          return d
        }
        }));
        console.log( bubunatm)
      //その他
      let other=_.clone(this.result.filter((d)=>{
        if((d.tenpo!==inputName)&&(d.atm!="1" )&&(d.atm!="2" )){
          return d
        }
        }));
        console.log( other)
        result=kanzen.concat(bubunTnpo).concat(bubunatm).concat(other);
        console.log( result)
        return result;
    },
    seachType: function() {
      return store.getters.searchType;
    }
  },
  watch: {
    results(val) {
      this.$nextTick(() => {
        this.resultLength = _.size(val);
      });
    },
    seachType(val) {
      const typeObj = localStorage.getItem('ncbAtm.type') ? JSON.parse(localStorage.getItem('ncbAtm.type')) : val;
      this.seachTypeText = typeObj.text;
    }
  },
  methods: {
    toFixedChange(distance) {
      return _.round(distance / 1000, 1).toFixed(1);
    },
    selectList(id) {
      this.$emit('select-list', id);
    },
    encodeURL(result) {
      return `http://maps.google.com/maps?q=${result.latitude},${result.longitude}`;
    }
  },
  mounted: function() {
    const typeObj = localStorage.getItem('ncbAtm.type') ? JSON.parse(localStorage.getItem('ncbAtm.type')) : store.getters.searchType;
    this.seachTypeText = typeObj.text;
  }
}
</script>
<style lang="scss" scoped>
.search_result_wrapper {
  overflow: auto;
}

.result_count {
  font-size: 13px;
  font-feature-settings: 'halt' on;
  color: #5C5C5C;
  margin: 16px 0 8px;
  overflow: auto;

  @media #{$small} {
    font-size: psd(13);
    margin: 24px 0 8px;
  }

  span {
    font-size: 20px;
    font-weight: 600;
    margin: 0 4px;
    color: #FE6B01;

    @media #{$small} {
      font-size: psd(20);
      margin: 0 psd(4);
    }
  }
}

.result_scroller {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 32px;

  @media #{$small} {
    padding-bottom: 0;
  }
}

.shop_list {
  border-bottom: 1px solid #EAEAEA;
  padding: 24px 0;

  dl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;

    dt {
      width: 60px;
      min-width: 60px;
      max-width: 60px;

      @media #{$small} {
        width: psd(60);
        min-width: psd(60);
        max-width: psd(60);
      }

      img {
        display: block;
        width: 100%;
      }
    }

    dd {
      width: 100%;
      margin: 0;
      padding: 0 23px 0 26px;
      position: relative;
      
      @media #{$small} {
        padding: 0 psd(23) 0 psd(16);
      }

      &:after {
        content: '';
        display: block;
        background: url('../../assets/images/map/card_arrow_right.svg') center center no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        bottom: 0;
        left: auto;
        right: 0;
        margin: auto;
        pointer-events: none;
        width: 16px;
        height: 16px;

        @media #{$small} {
          width: psd(16);
          height: psd(16);
        }
      }

      .shop_status {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        
        .badge {
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
          border-radius: 10px;
          height: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #FFFFFF;
          font-size: 10px;
          padding: 0 8px;
          line-height: 1;
          opacity: 0;
          white-space: nowrap;
  
          @media #{$small} {
            font-size: psd(10);
            padding: 0 psd(8);
          }
  
          &.sales {
            opacity: 1;
            background: #FDB348;
          }
  
          &.off_hours {
            opacity: 1;
            background: #B7B7B7;
          }
        }

        .atm_status {
          font-weight: bold;
          font-size: 12px;
          line-height: 1;
          color: #FCA01A;
          margin-left: 6px;

          @media #{$small} {
            font-size: psd(12);
            margin-left: psd(6);
          }
        }
      }


      .shop_name {
        margin: 0 0 8px;
        font-size: 13px;
        color: #5C5C5C;
        font-weight: bold;

        @media #{$small} {
          font-size: psd(13);
        }
      }

      .shop_address {
        margin: 0;
        color: #707070;
        font-size: 12px;
        @media #{$small} {
          font-size: psd(12);
        }

        .shop_postalcode {
          display: block;
        }
      }
    }
  }

  .shop_list_bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;

    .card_bottom_left {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        display: block;
        width: 24px;

        @media #{$small} {
          width: psd(24);
        }
      }

      span {
        display: block;
        line-height: 1;
        font-weight: 600;
        color: #607293;
        position: relative;
        top: 1px;
        font-size: 14px;

        @media #{$small} {
          font-size: psd(14);
        }
      }
    }

    .card_bottom_right {
      button,
      a {
        border: none;
        appearance: none;	
        background: #FFFFFF;
        border: 1px solid #EAEAEA;
        box-sizing: border-box;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        color: #FE6B01;
        font-weight: 600;
        text-align: center;
        font-size: 11px;
        padding: 10px 16px;

        @media #{$small} {
          font-size: psd(11);
          padding: 10px psd(16);
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  &:hover {
    cursor: pointer;
  }
}
</style>